import { validateEmail } from 'utils/validation';

export function mapMemberToPermissionsValues(member) {
  return {
    email: member.email || '',
    phoneNumber: member.phone_number || '',
    selectedPermissions: (member.roles || []).map((role) => role.id),
    selectedUnits: (member.units || []).map((unit) => unit.id),
  };
}

export function validatePermissions(values, messages) {
  const { email, selectedPermissions } = values;
  const errors = new Map();

  if (email === '') {
    errors.set('email', messages.FILL_REQUIRED);
  } else if (!validateEmail(email)) {
    errors.set('email', messages.INVALID_EMAIL_ERROR);
  }

  if (selectedPermissions.length === 0) {
    errors.set('permissions', messages.FILL_REQUIRED);
  }

  return errors;
}

export function buildPermissionsPayload(values) {
  const { email, phoneNumber, selectedPermissions, selectedUnits } = values;

  return {
    email,
    phone_number: phoneNumber,
    roles: selectedPermissions,
    units: selectedUnits,
  };
}
